<app-dialog
  #dialog
  [key]="'bank-kit-request'"
  [action]="'bank-kit-request'"
  [headerTheme]="'simple'"
  [title]="title()"
  [appendTo]="'body'"
  [maxWidth]="'1120px'">
  <div class="bank-kit">
    @if (loadingDraft()) {
      <div class="bank-kit__state">
        <app-cog-loading-spinner [size]="32" />
        <span>Montando o pedido com a lista do Kit Banco...</span>
      </div>
    } @else if (draftError()) {
      <div class="bank-kit__state bank-kit__state--error" role="alert">
        <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
        <span>{{ draftError() }}</span>
        <app-button
          label="Tentar de novo"
          theme="outline-grey"
          size="small"
          [type]="'button'"
          (sendButtonClick)="loadDraft()" />
      </div>
    } @else if (draft(); as d) {
      <!--
        `appAutoFormGroup` é OBRIGATÓRIO junto com o `[formGroup]`: sem ele os `app-input` criam
        controles próprios e o formulário do componente fica vazio (ver `modal-client-access`).
      -->
      <div class="bank-kit__grid" [formGroup]="form" appAutoFormGroup>
        <section class="bank-kit__form" aria-label="Pedido">
          <div class="bank-kit__reply">
            <i class="pi pi-inbox" aria-hidden="true"></i>
            <div>
              <strong>As respostas entram direto no Data Room da empresa.</strong>
              <span>
                O cliente responde este e-mail com os anexos e eles chegam em
                <code>{{ d.replyToAddress }}</code
                >, vão para a _TRIAGEM e o Cog guarda cada documento na pasta certa.
              </span>
            </div>
          </div>

          <div class="bank-kit__section">
            <div class="bank-kit__section-head">
              <span class="bank-kit__label">Para quem vai</span>
              <span class="bank-kit__hint">
                {{ selectedRecipients().length }} de até {{ d.maxRecipients }} pessoas
              </span>
            </div>

            @if (recipients().length) {
              <ul class="bank-kit__recipients">
                @for (r of recipients(); track r.email) {
                  <li>
                    <button
                      type="button"
                      class="bank-kit__recipient"
                      [class.is-selected]="r.selected"
                      [attr.aria-pressed]="r.selected"
                      (click)="toggleRecipient(r.email)">
                      <i
                        class="pi"
                        [class.pi-check-square]="r.selected"
                        [class.pi-stop]="!r.selected"
                        aria-hidden="true"></i>
                      <span class="bank-kit__recipient-text">
                        <span class="bank-kit__recipient-name">{{ r.name || r.email }}</span>
                        <span class="bank-kit__recipient-meta">
                          @if (r.name) {
                            {{ r.email }} ·
                          }
                          {{ describeSource(r.source) }}
                        </span>
                      </span>
                    </button>
                  </li>
                }
              </ul>
            } @else {
              <p class="bank-kit__empty">
                A empresa ainda não tem contato nem usuário com e-mail. Digite abaixo o e-mail de
                quem vai mandar os documentos.
              </p>
            }

            <div class="bank-kit__add">
              <app-input
                [type]="'email'"
                [label]="'Adicionar e-mail'"
                [placeholder]="'nome@empresa.com.br'"
                [controlName]="'manualEmail'"
                (keydown.enter)="$event.preventDefault(); addManualEmail()"></app-input>
              <app-button
                label="Adicionar"
                theme="outline-grey"
                icon="pi pi-plus"
                [type]="'button'"
                (sendButtonClick)="addManualEmail()" />
            </div>
            @if (manualEmailError()) {
              <small class="bank-kit__error" role="alert">{{ manualEmailError() }}</small>
            }
          </div>

          <div class="bank-kit__section">
            <app-input
              [type]="'text'"
              [label]="'Assunto'"
              [controlName]="'subject'"
              [maxLength]="200"
              [required]="true"></app-input>
          </div>

          <div class="bank-kit__section bank-kit__message">
            <div class="bank-kit__section-head">
              <span class="bank-kit__label">Mensagem</span>
              <button type="button" class="bank-kit__link" (click)="restoreDefaultText()">
                Restaurar texto padrão
              </button>
            </div>
            <app-input
              [type]="'textarea'"
              [controlName]="'message'"
              [maxLength]="8000"
              [required]="true"></app-input>
            <small class="bank-kit__hint">
              Linhas que começam com "- " viram uma lista no e-mail. A saudação ("Olá, nome") entra
              sozinha para cada pessoa.
            </small>
          </div>
        </section>

        <section class="bank-kit__preview" aria-label="Pré-visualização do e-mail">
          <div class="bank-kit__preview-head">
            <span class="bank-kit__label">Como o cliente vai receber</span>
            @if (loadingPreview()) {
              <span class="bank-kit__hint">Atualizando...</span>
            }
          </div>
          <dl class="bank-kit__envelope">
            <dt>Assunto</dt>
            <dd>{{ previewSubject() || form.get('subject')?.value }}</dd>
            <dt>Responder para</dt>
            <dd>{{ d.replyToAddress }}</dd>
          </dl>
          @if (previewHtml(); as html) {
            <iframe
              class="bank-kit__frame"
              title="Pré-visualização do e-mail do Kit Banco"
              sandbox=""
              [srcdoc]="html"></iframe>
          } @else {
            <div class="bank-kit__frame bank-kit__frame--empty">
              Preencha o assunto e a mensagem para ver o e-mail.
            </div>
          }
        </section>
      </div>
    }
  </div>

  <ng-template #footer>
    <div class="dialog__footer bank-kit-footer">
      <app-button
        label="Cancelar"
        theme="outline-grey"
        [type]="'button'"
        [disabled]="sending()"
        (sendButtonClick)="dialogRef?.close()" />
      <app-button
        icon="pi pi-send"
        [disabled]="!isFormValid()"
        [isLoading]="sending()"
        [loadingText]="'Enviando...'"
        [label]="sendLabel()"
        [type]="'button'"
        (sendButtonClick)="submitAction()"></app-button>
    </div>
  </ng-template>
</app-dialog>
